<template>
	<div>
		<div>
			<el-carousel
				:autoplay="false"
				arrow="never"
				type="card"
				height="230px"
				style="width: 70%; margin: 0 auto"
				@change="checkCard"
			>
				<el-carousel-item v-for="(card, idx) in cardList" :key="idx" :class="classAry[idx]">
					<div class="shop-card">
						<div>
							<div class="fs24 mgb10 textc">
								<b>{{ card.name }}</b>
							</div>
							<div class="cen">
								<div class="card-title">加购包包含<span></span></div>
								：
								<div class="card-content">{{ card.haveContent }}</div>
							</div>
							<div class="mb10 cen">
								<div class="card-title">售价<span></span></div>
								：
								<div class="card-content">
									￥<span class="fs24">{{ card.price }}</span
									>/{{ card.priceUnit }}
								</div>
							</div>
							<div class="cen" v-if="Number(card.renewPrice)">
								<div class="card-title">续费<span></span></div>
								：
								<div class="card-content">
									￥<span class="fs24">{{ card.renewPrice }}</span
									>/{{ card.priceUnit }}
								</div>
							</div>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 购买数量 -->
		<div style="margin-top: 50px">
			<slot name="buyOption"></slot>

			<div class="div-border"></div>

			<div class="buy">
				<div>
					总计：<span style="color: #e69752"
						>￥<b style="font-size: 24px">{{ totalPrice ? totalPrice : 0 }}</b></span
					>
				</div>
				<el-button
					size="small"
					style="background: #e69752; border: none; color: white; margin-right: 50px"
					@click="buyBtn"
					>点击购买</el-button
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			classAry: [],
			bgAry: ['bg1', 'bg2'],
			num: 1,
			checkCardData: {},
			carouselIdx: 0,
		}
	},
	props: {
		cardList: Array,
		totalPrice: Number,
	},
	watch: {
		cardList: {
			handler(newList) {
				if (newList.length == 0) return
				this.checkCardData = newList[this.carouselIdx]
				this.$emit('mb-check-card', this.checkCardData)
				this.cardList.forEach((item, idx) => {
					if (idx % 2 == 0) {
						this.classAry.push(...this.bgAry)
					}
				})
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		checkCard(idx) {
			this.carouselIdx = idx
			this.checkCardData = this.cardList[this.carouselIdx]
			this.$emit('mb-check-card', this.checkCardData)
		},
		buyBtn() {
			this.$emit('mb-buy-btn')
		},
	},
}
</script>

<style scoped>
.shop-card {
	/* width: 380px; */
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.bg1 {
	background: url('../assets/images/bg1.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: black;
}

.bg2 {
	background: url('../assets/images/bg2.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: #e9bd9c;
}

.text-between {
	text-align: justify;
	height: 50px;
	line-height: 50px;
}
.text-between > i {
	display: inline-block /* Opera */;
	padding-left: 100%;
}

.text-height {
	height: 50px;
	line-height: 50px;
	text-align: right;
}

.buy {
	display: flex;
	justify-content: space-between;
	align-items: baseline;
}
</style>
